import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import axios from "axios";
import API_BASE_URL from "../../../src/config";
import { toast } from "react-toastify";

// const Amenities = forwardRef(({ propStayId }, ref) => {
//   const stayId = propStayId || localStorage.getItem("stayId") | "a06057ae-106d-42c3-b127-a76c913fdda6" ; // use passed stayId or localStorage
//   const [amenities, setAmenities] = useState([]);
//   const [selectedAmenities, setSelectedAmenities] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   // Fetch amenities on mount
//   useEffect(() => {
//     const fetchAmenities = async () => {
//       try {
//        // const res = await axios.get("http://localhost:3000/api/v1/stays/amenities");
//         const res = await axios.get(`${API_BASE_URL}stays/amenities`);
//         if (res.data.success) {
//           setAmenities(res.data.data);
//         }
//       } catch (error) {
//         console.error("Error fetching amenities:", error);
//       }
//     };
//     fetchAmenities();
//   }, []);

//   // Toggle selection
//   const handleAmenityChange = (id) => {
//     setSelectedAmenities((prev) =>
//       prev.includes(id)
//         ? prev.filter((amenityId) => amenityId !== id)
//         : [...prev, id]
//     );
//   };

//   // Expose methods to parent
//   useImperativeHandle(ref, () => ({
//     getData: () => ({
//       stayId,
//       amenities: selectedAmenities,
//     }),
//     submit: async () => {
   
//       console.log("Submitting amenities for stayId:", stayId);
//       if (!stayId) {
//         setMessage("Stay ID not found.");
//         return;
//       }

//       setLoading(true);
//       setMessage("");

//       try {
//         const token = localStorage.getItem("accessToken"); // or get it from props/context
//         const res = await axios.post(
//           // "http://localhost:3000/api/v1/stays/add-amenities",
//           `${API_BASE_URL}stays/add-amenities`,
//           {
//             stayId,
//             amenities: selectedAmenities,
//           },
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         if (res.data.success) {
//           alert("Amenities saved successfully!");
//           setMessage("Amenities saved successfully!");
//         } else {
//           setMessage(res.data.message || "Failed to save amenities.");
//         }
//       } catch (error) {
//         console.error("Error submitting amenities:", error);
//         setMessage("Error submitting amenities.");
//       } finally {
//         setLoading(false);
//       }
//     },
//   }));

//   return (
//     <div className="tab-section">
//       <h4 className="mb-3">Select Amenities</h4>

//       <div className="row">
//         {amenities.length === 0 ? (
//           <div className="col-12">
//             <p>Loading amenities...</p>
//           </div>
//         ) : (
//           amenities.map((amenity) => (
//             <div
//               className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-3"
//               key={amenity.id}
//             >
//               <div className="form-check">
//                 <input
//                   className="form-check-input"
//                   type="checkbox"
//                   id={`amenity-${amenity.id}`}
//                   checked={selectedAmenities.includes(amenity.id)}
//                   onChange={() => handleAmenityChange(amenity.id)}
//                 />
//                 <label
//                   className="form-check-label"
//                   htmlFor={`amenity-${amenity.id}`}
//                 >
//                   {amenity.name}
//                 </label>
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       {message && <p className="mt-3">{message}</p>}
//       {loading && <p>Submitting amenities...</p>}
//     </div>
//   );
// });

// export default Amenities;



const Amenities = forwardRef(({ propStayId }, ref) => {
  const stayId =
    propStayId ||
    localStorage.getItem("stayId"); // fallback stayId

  const [amenities, setAmenities] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Fetch all amenities on mount
  useEffect(() => {
    const fetchAmenities = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}stays/amenities`);
        if (res.data.success) {
          setAmenities(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching amenities:", error);
      }
    };

    fetchAmenities();
  }, []);

  // Fetch stay details to get pre-selected amenities
  useEffect(() => {
    const fetchStayDetails = async () => {
      if (!stayId) return;

      try {
        const token = localStorage.getItem("accessToken");
        const res = await axios.post(
          `${API_BASE_URL}stays/details`,
          { id: stayId },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (res.data.success && res.data.data?.amenities) {
          const existing = res.data.data.amenities.map((a) => a.id);
          setSelectedAmenities(existing);
        }
      } catch (error) {
        console.error("Error fetching stay details:", error);
      }
    };

    fetchStayDetails();
  }, [stayId]);

  // Toggle selection
  const handleAmenityChange = (id) => {
    setSelectedAmenities((prev) =>
      prev.includes(id)
        ? prev.filter((amenityId) => amenityId !== id)
        : [...prev, id]
    );
  };

  // Expose methods to parent
  useImperativeHandle(ref, () => ({
    getData: () => ({
      stayId,
      amenities: selectedAmenities,
    }),
    submit: async () => {
      console.log("Submitting amenities for stayId:", stayId);
      if (!stayId) {
        setMessage("Stay ID not found.");
        return;
      }

      setLoading(true);
      setMessage("");

      try {
        const token = localStorage.getItem("accessToken");
        const res = await axios.post(
          `${API_BASE_URL}stays/add-amenities`,
          {
            stayId,
            amenities: selectedAmenities,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data.success) {
          toast.success("Amenities saved successfully!");
          setMessage("Amenities saved successfully!");
        } else {
          toast.error(res.data.message || "Failed to save amenities.");
        }
      } catch (error) {
        console.error("Error submitting amenities:", error);
        toast.error("Error submitting amenities.");
      } finally {
        setLoading(false);
      }
    },
  }));

  return (
    <div className="tab-section">
      <h4 className="mb-3">Select Amenities</h4>

      <div className="row">
        {amenities.length === 0 ? (
          <div className="col-12">
            <p>Loading amenities...</p>
          </div>
        ) : (
          amenities.map((amenity) => (
            <div
              className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-3"
              key={amenity.id}
            >
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`amenity-${amenity.id}`}
                  checked={selectedAmenities.includes(amenity.id)}
                  onChange={() => handleAmenityChange(amenity.id)}
                />
                <label
                  className="form-check-label"
                  htmlFor={`amenity-${amenity.id}`}
                >
                  {amenity.name}
                </label>
              </div>
            </div>
          ))
        )}
      </div>

      {/* {message && <p className="mt-3">{message}</p>} */}
      {loading && <p>Submitting amenities...</p>}
    </div>
  );
});

export default Amenities;